/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useRef, useState } from "react";
import Layout from "../components/layout";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import "react-spring-bottom-sheet/dist/style.css";
import { s3Url } from "../utils/constants";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import MarqueeComponent from "../components/MarqueeComponent";
import SearchEmptyStateComponent from "../components/SearchEmptyStateComponent";
import FilterModal from "../components/FilterModal";
import MarqueeCardItemComponent from "../components/MarqueeCardItemComponent";
import HeaderComponent from "../components/HeaderComponent";
import FilterButton from "../assets/images/filter.svg";
import LocationIcon from "../assets/images/location.svg";
import CloseIcon from "../assets/images/close.svg";
import ModalComponent from "../components/ModalComponent";
import arrowRightWhiteIcon from "../assets/images/arrow-right-white.svg";
import defaultImage from "../assets/images/default.png";

const Directory = observer(() => {
  const { id } = useParams();
  const { generalStore } = useStores();

  useEffect(() => {
    generalStore.activePage = "directory";
    initData();
  }, []);

  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [poiList, setPoiList] = useState([]);
  const [selectedPoi, setSelectedPoi] = useState(null);
  const [query, setQuery] = useState("");
  const [categoryList, setCategoryList] = useState([]);

  function onDismiss() {
    setOpen(false);
    setOpenModal(false);
  }
  const navigate = useHistory();

  // Filtering
  const [isShowLevel, setIsShowLevel] = useState(false);
  const [isApplyFilter, setIsApplyFilter] = useState(false);

  const changeSelectedLevel = (floor) => {
    if (selectedLevel.includes(floor)) {
      setSelectedLevel(selectedLevel.filter((cat) => cat !== floor));
    } else {
      setSelectedLevel([floor]);
    }
  };

  const changeSelectedCategory = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(
        selectedCategories.filter((cat) => cat !== category),
      );
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  let timeout;

  const handleInputChange = (event) => {
    clearTimeout(timeout); // Clear previous timeout
    const value = event.target.value;
    setQuery(value);
    timeout = setTimeout(() => {
      filterData(value);
    }, 300);
  };

  const initData = () => {
    let data = generalStore.pois.reduce((r, e) => {
      // get first letter of name of current element
      let group = e.name[0];
      // if there is no property in accumulator with this letter create it
      if (!r[group]) r[group] = { group, children: [e] };
      // if there is push current element to children array for that letter
      else r[group].children.push(e);
      // return accumulator
      return r;
    }, {});
    setPoiList(Object.values(data));
    setCategoryList(Object.values(generalStore.allCategories));
  };
  // since data at this point is an object, to get array of values
  // we use Object.values method
  const filterData = (searchQuery) => {
    const filteredItems = generalStore.pois.filter((item) => {
      return (
        (searchQuery == ""
          ? true
          : item.name
              .toLocaleLowerCase()
              .includes(searchQuery.toLocaleLowerCase())) &&
        (selectedCategories.length > 0
          ? item.categoryIds.some((category) =>
              selectedCategories.includes(category),
            )
          : true) &&
        (selectedLevel.length > 0
          ? item.floorName && selectedLevel.includes(item.floorName)
          : true)
      );
    });
    let data = filteredItems.reduce((r, e) => {
      // get first letter of name of current element
      let group = e.name[0];
      // if there is no property in accumulator with this letter create it
      if (!r[group]) r[group] = { group, children: [e] };
      // if there is push current element to children array for that letter
      else r[group].children.push(e);
      // return accumulator
      return r;
    }, {});
    setPoiList(Object.values(data));
    setIsApplyFilter(true);
    setOpen(false);
  };

  const resetFilter = () => {
    // reset filter parameter
    setIsApplyFilter(false);
    setSelectedCategories([]);
    setSelectedLevel([]);
    setQuery("");
    setIsShowLevel(false);
    // reset list data
    let data = generalStore.pois.reduce((r, e) => {
      // get first letter of name of current element
      let group = e.name[0];
      // if there is no property in accumulator with this letter create it
      if (!r[group]) r[group] = { group, children: [e] };
      // if there is push current element to children array for that letter
      else r[group].children.push(e);
      // return accumulator
      return r;
    }, {});
    setPoiList(Object.values(data));
  };

  const ResponsiveImage = ({ src, alt, ratio = "16:9" }) => {
    // Convert ratio string to number (e.g., '16:9' -> 56.25)
    const getPaddingTop = () => {
      const [width, height] = ratio.split(":").map(Number);
      return (height / width) * 100;
    };

    return (
      <div className="w-full relative">
        <div
          className="w-full"
          style={{
            paddingTop: `${getPaddingTop()}%`,
          }}
        >
          <img
            src={src}
            alt={alt}
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
        </div>
      </div>
    );
  };

  return (
    <Layout>
      <div className="h-full w-full flex flex-col overflow-hidden">
        <HeaderComponent title={"Directory"} />
        <div className="h-full w-full flex flex-col items-center overflow-hidden bg-whiteBg">
          <div className="flex flex-row w-full items-center justify-center gap-2 px-4 pt-6 pb-3 overflow-hidden">
            <div className="flex-grow relative flex items-center w-full h-10 rounded-lg focus-within:shadow-lg bg-white">
              <input
                className="peer h-full w-full outline-none text-sm text-gray-700 px-3"
                type="text"
                id="search"
                value={query}
                onChange={handleInputChange}
                placeholder="Your Location"
              />
              <div className="grid place-items-center h-full w-12 text-gray-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
            {query.length ? (
              <img
                src={CloseIcon}
                className="w-6 h-6"
                onClick={() => resetFilter()}
              />
            ) : (
              <div
                className="flex bg-white w-10 h-10 items-center justify-center rounded-md"
                onClick={() => setOpen(true)}
              >
                <img src={FilterButton} className="w-6 h-6" />
              </div>
            )}
          </div>

          {poiList.length > 0 ? (
            <div className="h-[calc(100vh-10rem)] w-full grid grid-cols-1 gap-4 p-4 content-start overflow-scroll">
              {poiList.map((e) => {
                return (
                  <div
                    key={e.group + "group"}
                    className="w-full h-auto flex flex-col gap-2"
                  >
                    <span className="text-sm font-medium text-gray-400">
                      {e.group}
                    </span>
                    <div className="flex flex-col w-full gap-2">
                      {e.children.map((poi) => {
                        return poi.uniqueId ? (
                          <Link
                            to={`/directory/${poi.uniqueId}`}
                            key={poi.id}
                            className="bg-white rounded-lg flex flex-row gap-2"
                          >
                            <img
                              src={(() => {
                                try {
                                  return poi.logo
                                    ? `${s3Url}/poi/${poi.logo}`
                                    : defaultImage;
                                } catch (error) {
                                  return defaultImage;
                                }
                              })()}
                              className="object-cover w-24 h-24 rounded-s-lg"
                            />
                            <div className="flex flex-col items-start justify-center overflow-hidden gap-1">
                              <MarqueeCardItemComponent content={poi.name} />

                              <span className="font-light text-xs text-gray-400">
                                {(() => {
                                  try {
                                    const category = categoryList.filter(
                                      (cat) => cat._id === poi.categoryId,
                                    );

                                    return category[0].name
                                      ? category[0].name
                                      : "Category";
                                  } catch (error) {
                                    return "Category";
                                  }
                                })()}
                              </span>
                              <div className="flex flex-row gap-2 items-center justify-center">
                                <img
                                  src={LocationIcon}
                                  className="object-contain w-3 h-3"
                                />
                                <div className="flex-grow">
                                  <span className="text-primary font-light text-xs line-clamp-1">
                                    {(() => {
                                      try {
                                        return poi.location ? poi.location : "";
                                      } catch (error) {
                                        return "";
                                      }
                                    })()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        ) : (
                          <div
                            className="bg-white rounded-lg flex flex-row gap-2 cursor-pointer"
                            key={poi.id}
                            onClick={() => {
                              setSelectedPoi(poi);
                            }}
                          >
                            <img
                              src={(() => {
                                try {
                                  return poi.logo
                                    ? `${s3Url}/poi/${poi.logo}`
                                    : defaultImage;
                                } catch (error) {
                                  return defaultImage;
                                }
                              })()}
                              className="object-cover w-24 h-24 rounded-s-lg"
                            />
                            <div className="flex flex-col items-start justify-center overflow-hidden gap-1">
                              <MarqueeCardItemComponent content={poi.name} />

                              <span className="font-light text-xs text-gray-400">
                                {(() => {
                                  try {
                                    const category = categoryList.filter(
                                      (cat) => cat._id === poi.categoryId,
                                    );

                                    return category[0].name
                                      ? category[0].name
                                      : "Category";
                                  } catch (error) {
                                    return "Category";
                                  }
                                })()}
                              </span>
                              <div className="flex flex-row gap-2 items-center justify-center">
                                <img
                                  src={LocationIcon}
                                  className="object-contain w-3 h-3"
                                />
                                <div className="flex-grow">
                                  <span className="text-primary font-light text-xs line-clamp-1">
                                    {(() => {
                                      try {
                                        return poi.location ? poi.location : "";
                                      } catch (error) {
                                        return "";
                                      }
                                    })()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <SearchEmptyStateComponent
              selectedCategories={selectedCategories}
              selectedFloor={selectedLevel}
              isSearchView={false}
            />
          )}
        </div>
      </div>
      <FilterModal
        open={open}
        setOpen={() => {
          setOpen(false);
          if (!isApplyFilter) {
            resetFilter();
          }
        }}
        onDismiss={() => {
          filterData(query);
          onDismiss();
        }}
        selectedCategories={selectedCategories}
        selectedLevel={selectedLevel}
        allCategories={generalStore.allCategories}
        toggleCategory={changeSelectedCategory}
        toggleLevel={changeSelectedLevel}
        floors={generalStore.floors}
        filterData={filterData}
        query={query}
      />
      {selectedPoi && (
        <ModalComponent isOpen={selectedPoi}>
          <div className="flex flex-col h-full w-full">
            <div className="h-full w-full overflow-y-scroll rounded-xl">
              <div className="relative">
                <ResponsiveImage
                  src={(() => {
                    try {
                      return selectedPoi.logo
                        ? `${s3Url}/poi/${selectedPoi.logo}`
                        : defaultImage;
                    } catch (error) {
                      return defaultImage;
                    }
                  })()}
                  ratio="4:3"
                />
                <div className="absolute top-0 right-0 p-2">
                  <img
                    className="h-6 w-6"
                    src={CloseIcon}
                    onClick={() => {
                      setSelectedPoi(null);
                    }}
                  />
                </div>
              </div>
              <div className="p-4 flex flex-col gap-2">
                <MarqueeComponent
                  content={selectedPoi.name}
                  spanClassName="text-lg"
                />

                <h3 className="font-light text-sm text-gray-400">
                  {(() => {
                    try {
                      const category = categoryList.filter(
                        (cat) => cat._id === selectedPoi.categoryId,
                      );

                      return category[0].name ? category[0].name : "Category";
                    } catch (error) {
                      return "Category";
                    }
                  })()}
                </h3>
                <div className="flex flex-row gap-2">
                  <img src={LocationIcon} className="object-contain w-4" />
                  <span className="text-primary font-light text-sm line-clamp-1">
                    <MarqueeComponent content={selectedPoi.location} />
                  </span>
                </div>
                <div
                  className="prose text-sm font-light text-gray-400"
                  dangerouslySetInnerHTML={{
                    __html: selectedPoi.description,
                  }}
                />
              </div>
            </div>
            {selectedPoi.location && (
              <div className="px-4 my-4">
                <div
                  className="flex items-center justify-center p-3 bg-[#12529C] text-[#FFFFFF] border-[rgba(18, 82, 156, 0.12)] rounded-full "
                  onClick={() => {}}
                >
                  Get Direction&nbsp;
                  <img className="w-5 h-5" src={arrowRightWhiteIcon} />
                </div>
              </div>
            )}
          </div>

          {openModal && (
            <div className="w-screen h-screen absolute top-0 r-0 z-50 bg-[#00000066] flex flex-col items-center justify-center p-4">
              <div className="flex flex-col bg-white w-full rounded-lg p-4 gap-4">
                <div className="flex flex-row justify-end">
                  <img
                    src={require("../assets/images/x.svg")}
                    alt=""
                    onClick={() => {
                      setOpenModal(false);
                    }}
                  />
                </div>
                <div className="flex flex-row justify-between gap-4">
                  <div
                    className="flex flex-col gap-2 items-center justify-center px-4 py-8 bg-[#FCF4EB] rounded-lg w-full"
                    onClick={() => {
                      generalStore.tmtType = "stair";
                      navigate.push("/wayfinder");
                    }}
                  >
                    <img
                      src={require("../assets/images/stair.svg")}
                      className="aspect-square w-20 h-20"
                    />
                    <span className="font-bold text-sm text-gray-500">
                      Staircase Access
                    </span>
                  </div>
                  <div
                    className="flex flex-col gap-2 items-center justify-center px-4 py-8 bg-[#FCF4EB] rounded-lg w-full"
                    onClick={() => {
                      generalStore.tmtType = "lift";
                      navigate.push("/wayfinder");
                      // setOpenModal(false);
                      // onTakeMeThere(true);
                      // setDetail(false);
                    }}
                  >
                    <img
                      src={require("../assets/images/lift.svg")}
                      className="aspect-square w-20 h-20"
                    />
                    <span className="font-bold text-sm text-gray-500">
                      Lift Access
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </ModalComponent>
      )}
    </Layout>
  );
});

export default Directory;
